export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/232d3fde-3317-4fc7-ba5a-f94916cb5827.jpg'

export const price = {
  reference: '$96.990',
  current: '$16.990',
  savings: '$80.000',
}

export const excuses = [
  'Esta vez sí voy a comer mejor.',
  'Desde el lunes empiezo el gimnasio.',
  'Voy a dejar los carbohidratos.',
  'Voy a hacer más cardio.',
  'Voy a comer muchísimo menos.',
  'Después de las vacaciones arranco.',
]

export const interruptions = [
  'Un cumpleaños.',
  'Una salida.',
  'Un día de mucho trabajo.',
  'Falta de motivación.',
  'Cansancio.',
  'Hambre.',
  'Un fin de semana.',
]

export const infoSources = [
  'TikTok',
  'Instagram',
  'YouTube',
  'Dietas',
  'Rutinas',
  'Recetas',
  'Influencers',
  'Aplicaciones',
  'Calculadoras',
]

export const systemNeeds = [
  'qué hacer',
  'cómo organizarse',
  'cómo entrenar',
  'cómo medir el progreso',
  'qué hacer cuando las cosas no salen perfectas',
]

export type Volume = {
  number: number
  title: string
  intro: string
  topics: string[]
  closing: string
}

export const volumes: Volume[] = [
  {
    number: 1,
    title: 'El método de 45 días',
    intro: 'Vas a entender:',
    topics: [
      'cómo funciona la pérdida de grasa',
      'qué es realmente un déficit calórico',
      'qué papel cumple el metabolismo',
      'qué factores determinan tus resultados',
      'cómo medir tu progreso',
      'cuáles son los errores más comunes',
    ],
    closing: 'Para dejar de depender de mitos y empezar a entender el proceso.',
  },
  {
    number: 2,
    title: 'Alimentación para perder grasa',
    intro: 'Aprendé a construir una alimentación que puedas sostener.',
    topics: [
      'calorías',
      'proteínas',
      'carbohidratos',
      'grasas',
      'fibra',
      'hidratación',
      'porciones',
      'comidas',
      'snacks',
      'restaurantes',
      'eventos',
      'fines de semana',
      'antojos',
      'comidas libres',
      'planificación',
      'compras',
    ],
    closing: 'Sin necesidad de vivir a base de pollo y arroz.',
  },
  {
    number: 3,
    title: 'Entrenamiento para la recomposición corporal',
    intro: 'Aprendé a entrenar con propósito.',
    topics: [
      'entrenamiento de fuerza',
      'progresión',
      'series y repeticiones',
      'descanso',
      'RIR',
      'técnica',
      'core',
      'cardio',
      'pasos',
      'recuperación',
      'rutinas de 3 días',
      'rutinas de 4 días',
      'entrenamiento en casa',
    ],
    closing:
      'No entrenes solamente para quemar calorías. Aprendé a entrenar para construir un cuerpo más fuerte.',
  },
  {
    number: 4,
    title: 'Los 45 días paso a paso',
    intro: 'Este es el corazón del programa. No vas a tener que preguntarte: “¿Y ahora qué hago?” Tenés una estructura día por día.',
    topics: [],
    closing: '45 días de acciones concretas.',
  },
  {
    number: 5,
    title: 'Psicología, hábitos y adherencia',
    intro: 'Porque saber qué hacer no alcanza. Este volumen te ayuda a trabajar:',
    topics: [
      'motivación',
      'disciplina',
      'hábitos',
      'hambre',
      'antojos',
      'estrés',
      'sueño',
      'fines de semana',
      'eventos',
      'comidas afuera',
      'días difíciles',
      'pensamiento “todo o nada”',
      'relación con la balanza',
      'recaídas',
    ],
    closing: 'Porque un plan perfecto que abandonás no sirve.',
  },
  {
    number: 6,
    title: 'Después de los 45 días',
    intro: '¿Y después qué? Esta es una de las preguntas más importantes. Aprendé:',
    topics: [
      'qué hacer cuando termina el déficit',
      'cómo pensar el mantenimiento',
      'cómo evaluar tu progreso',
      'qué hacer si recuperás peso',
      'cómo seguir perdiendo grasa',
      'cómo cambiar el objetivo hacia músculo',
      'cómo organizar los siguientes 90 días',
      'cómo evitar volver al punto de partida',
    ],
    closing: 'Porque los 45 días no deberían ser el final.',
  },
]

export const milestones = [
  { day: 1, label: 'Empezar.' },
  { day: 7, label: 'Primer check-in.' },
  { day: 14, label: 'Evaluación.' },
  { day: 21, label: 'Primer gran análisis.' },
  { day: 30, label: 'Ajuste.' },
  { day: 35, label: 'Evaluación.' },
  { day: 45, label: 'Evaluación final.' },
]

export type Bonus = {
  number: number
  title: string
  image: string
  imageAlt: string
  intro: string
  itemsLabel?: string
  items: string[]
  itemStyle: 'chips' | 'questions' | 'avoid'
  closing: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'Planificador de 45 días',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b96df11c-df77-44a3-ac85-4d439de4d738.jpg',
    imageAlt: 'Planificador impreso en un portapapeles junto a una pesa rusa y una cinta métrica',
    intro: 'Tu herramienta para llevar el programa a la práctica.',
    itemsLabel: 'Podrás registrar:',
    items: ['entrenamientos', 'alimentación', 'peso', 'medidas', 'hábitos', 'actividad', 'progreso'],
    itemStyle: 'chips',
    closing: 'Menos improvisación. Más organización.',
  },
  {
    number: 2,
    title: '50 comidas fitness',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/af2639c1-823e-4aae-a5b3-a831e380f9ac.jpg',
    imageAlt: 'Bowls de comidas saludables con pollo, salmón y avena',
    intro: 'Ideas prácticas para no caer siempre en las mismas comidas.',
    itemsLabel: 'Opciones para:',
    items: ['desayunos', 'almuerzos', 'cenas', 'meriendas', 'snacks'],
    itemStyle: 'chips',
    closing: 'Comer mejor no tiene que ser aburrido.',
  },
  {
    number: 3,
    title: 'Lista de compras inteligente',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/cb0c3ffc-06b0-4c8b-86b9-a871950b54af.jpg',
    imageAlt: 'Bolsa de compras con alimentos saludables',
    intro: 'Una guía para saber qué tener en casa.',
    itemsLabel: 'Organizada por categorías:',
    items: ['proteínas', 'carbohidratos', 'frutas', 'vegetales', 'grasas', 'snacks', 'básicos'],
    itemStyle: 'chips',
    closing: 'Porque una buena alimentación empieza antes de sentarte a comer.',
  },
  {
    number: 4,
    title: 'Calculadora de calorías y macros',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/cd3ca265-aad2-4f58-ad91-910b8d7f7a92.jpg',
    imageAlt: 'Celular con gráfico de macros junto a una balanza de cocina',
    intro: 'Una herramienta para ayudarte a estimar tus necesidades y organizar tu alimentación.',
    itemsLabel: 'Aprendé a entender:',
    items: ['calorías', 'proteínas', 'grasas', 'carbohidratos'],
    itemStyle: 'chips',
    closing: 'Sin depender de números al azar.',
  },
  {
    number: 5,
    title: 'Guía “¿Qué hago cuando…?”',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4845ff58-06ae-48f0-8344-955797d73d27.jpg',
    imageAlt: 'Porción de torta de cumpleaños, pasaporte y zapatillas',
    intro: '',
    items: [
      '¿Qué hago cuando tengo un cumpleaños?',
      '¿Qué hago si como de más?',
      '¿Qué hago si no puedo entrenar?',
      '¿Qué hago si tengo un viaje?',
      '¿Qué hago si me da un antojo?',
      '¿Qué hago si me estanco?',
      '¿Qué hago si pierdo la motivación?',
    ],
    itemStyle: 'questions',
    closing: 'Una guía rápida para los momentos en los que más fácil es abandonar.',
  },
  {
    number: 6,
    title: 'Guía para acelerar resultados sin hacer locuras',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/1c3db657-84a9-4591-a3d4-4e1d79315c05.jpg',
    imageAlt: 'Cronómetro, vaso de agua con limón y mancuernas',
    intro: 'Cómo mejorar tu proceso sin caer en:',
    items: [
      'dietas extremas',
      'hambre constante',
      'cardio interminable',
      'entrenamientos excesivos',
      'suplementos milagrosos',
    ],
    itemStyle: 'avoid',
    closing: 'Aprendé dónde realmente vale la pena poner tu esfuerzo.',
  },
]

export const systemSummary = ['6 volúmenes', '6 bonos', '45 días de estructura', 'Herramientas prácticas']

export const whatYouGet = [
  'Una estructura de 45 días.',
  'Un método completo.',
  'Un sistema de alimentación.',
  'Un sistema de entrenamiento.',
  'Herramientas de seguimiento.',
  'Estrategias de adherencia.',
  'Plan para después de los 45 días.',
  'Bonos prácticos.',
]

export const forWho = [
  'Querés reducir grasa corporal.',
  'Querés mejorar tu composición corporal.',
  'Te cuesta mantener constancia.',
  'Empezás dietas y las abandonás.',
  'No sabés cómo organizar tus comidas.',
  'Vas al gimnasio pero no tenés una estrategia clara.',
  'Querés dejar de depender de soluciones extremas.',
  'Querés una estructura simple para empezar.',
  'Querés aprender qué hacer después de conseguir resultados.',
]

export const notForWho = [
  'Una transformación milagrosa.',
  'Perder una cantidad específica de kilos garantizada.',
  'Una dieta extrema.',
  'Resultados sin esfuerzo.',
  'Un suplemento mágico.',
  'Una solución de una semana.',
]

export const whyReasons = [
  'implementar cambios',
  'repetir hábitos',
  'aprender',
  'medir',
  'ajustar',
  'adaptarte',
  'construir consistencia',
]

export const day45Outcomes = [
  'Aprendiste a organizar tus comidas.',
  'Aprendiste a entrenar.',
  'Entendés mejor las calorías.',
  'Sabés qué hacer cuando salís a comer.',
  'Sabés cómo manejar un mal día.',
  'Tenés una estructura.',
  'Sabés cómo medir tu progreso.',
  'Sabés qué hacer después.',
]

export const postponements = [
  'Después de las vacaciones.',
  'Después del cumpleaños.',
  'Después del viaje.',
  'Cuando tenga más tiempo.',
  'Cuando esté motivado.',
]

export const pillars = ['Alimentación', 'Entrenamiento', 'Hábitos', 'Adherencia', 'Seguimiento', 'Mantenimiento']

export const notNeeded = [
  'No necesitás ser perfecto.',
  'No necesitás saberlo todo.',
  'No necesitás tener una motivación increíble.',
]

export const repeatSteps = ['un día.', 'una comida.', 'un entrenamiento.', 'una decisión.']
